export enum PropertyBagFeatureEnum {
  MENU_ROOT = "menu_root_page",
}
